/**
 * Created by vladislav on 12/19/2023
 */

const FeedableView = function (feedable, unitView) {
    this.feedable = feedable;
    this.unitView = unitView;

    this.updateFeedIcon(feedable.state === Feedable.STATE_HUNGRY);
};

FeedableView.prototype.updateFeedIcon = function (visible) {
    if (visible && !this.feedIcon) {
        const styles = cleverapps.styles.FeedableView.bubble;
        this.feedIcon = new cc.Sprite(bundles.merge.frames.feedable_prizeview);
        this.unitView.addChild(this.feedIcon, -1);
        this.feedIcon.setAnchorPoint(0.5, 0);
        this.feedIcon.setAlignment(this.unitView.width / 2 + styles.unitOffset.x, this.unitView.height + styles.unitOffset.y);
        this.feedIcon.setVisible(false);
        this.feedIcon.runAction(StandartAnimations.showUp(this.feedIcon));

        const foodIcon = new cc.Sprite(this.feedable.getImageForFood());
        this.feedIcon.addChild(foodIcon);
        foodIcon.setAlignment(styles.food);
        cleverapps.UI.fitToBox(foodIcon, styles.food);

        cleverapps.UI.onClick(this.feedIcon, () => {
            this.unitView.handleClick();
        });
    }

    if (!visible && this.feedIcon) {
        this.feedIcon.stopAllActions();
        this.feedIcon.runAction(
            StandartAnimations.disappear(this.feedIcon),
            new cc.RemoveSelf()
        );
        delete this.feedIcon;
    }
};

FeedableView.prototype.clearAnimations = function () {
    if (this.unitView.sprite instanceof cleverapps.Spine) {
        this.unitView.sprite.setCompleteListener();
    }
};

FeedableView.prototype.feed = function () {
    if (this.unitView.sprite instanceof cleverapps.Spine && this.unitView.sprite.hasAnimation("feed")) {
        this.unitView.sprite.setAnimation(0, "feed", false);
        this.unitView.sprite.setCompleteListener(() => {
            UnitView.applyDefaultAnimation(this.unitView.sprite, this.feedable.unit);
        });
        this.unitView.sprite.setSafeToRemove();
    } else {
        this.unitView.squeeze();
    }
};

cleverapps.styles.FeedableView = {
    bubble: {
        unitOffset: {
            x: 50,
            y: -10
        },

        food: {
            width: 80,
            height: 80,

            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 20 }

        }
    }
};